import { createAction } from "redux-actions";
import { GET_LEVELS_CORE } from "../constants";
import { feathersCreateData } from "../services";

export const getLevelsCore = createAction(GET_LEVELS_CORE, (data) => feathersCreateData('core-server', {
    service: 'COLLECTIONS',
    func: 'GET_LEVEL_STUDIES',
    data
})())